<script setup lang="ts">
// Imports
import StreamPlayer from '~/components/partials/StreamPlayer.vue';
import { NakedImage } from 'vue-datocms';

// Types
import type { HeaderMediaFragment } from '#gql';

defineProps<{
  asset: HeaderMediaFragment['asset'];
}>();

const imageStyle = {
  maxWidth: '100%',
  height: '100%',
  objectFit: 'cover',
};
</script>

<template>
  <div class="asset-container">
    <StreamPlayer
      v-if="asset?.mimeType.includes('video')"
      class="video"
      :mux-playback-id="asset.video?.muxPlaybackId ?? ''"
      :mux-streaming-url="asset.video?.streamingUrl ?? ''"
      autoplay
    />
    <template v-else-if="asset?.mimeType.includes('image')">
      <NakedImage
        v-if="asset.imageLandscape"
        :data="asset.imageLandscape"
        :img-class="'_hidden-vs'"
        :img-style="imageStyle"
      />
      <NakedImage
        v-if="asset.imagePortrait"
        :data="asset.imagePortrait"
        :img-class="'_hidden-vl'"
        :img-style="imageStyle"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.asset-container,
.asset-container > .video {
  width: 100%;
  height: 100%;
}
</style>
